import { Stack, Typography, Button } from '@mui/material';

const BookContextList = ({ contexts, deleteHandler }) => {
  return (
    <Stack direction="column">
      {contexts.map((context) => (
        <Stack
          direction="row"
          key={context._id}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '10px',
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <Typography key={context._id}>{context.orginal_file_name}</Typography>
          <Button variant="contained" color="error" onClick={() => deleteHandler(context._id)}>
            Delete
          </Button>
        </Stack>
      ))}
    </Stack>
  );
};

export default BookContextList;
